import React from 'react';
import { colors } from '@styles/colors';

function LabelCarga({ nombre = 'información' }) {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      flexDirection: 'column', 
      height: '20vh', 
      width: '100%', 
      gap: '1vh' 
    }}> 
      <span style={{ 
        fontSize: '2.2vh', 
        fontFamily: 'Inter', 
        fontWeight: '600', 
        color: colors.primaryText, 
        textAlign: 'center' 
      }}> 
        Cargando {nombre} ... 
      </span> 
      <span style={{ 
        fontSize: '1.4vh', 
        fontFamily: 'Inter', 
        color: colors.gray600, 
        textAlign: 'center' 
      }}> 
        Por favor espere un momento 
      </span> 
    </div>
  );
}

export default LabelCarga;
